import React from 'react';

const SkillTag = ({ tag, onClick }) => {
  return (
    <span
      className="inline-block bg-apple-gray-200 hover:bg-apple-gray-300 text-apple-gray-700 text-sm px-3 py-1 rounded-full cursor-pointer transition-colors duration-200"
      onClick={() => onClick && onClick(tag)}
    >
      {tag}
    </span>
  );
};

export default SkillTag;